module.exports = __webpack_public_path__ + "img/p2-3.752caa20.png";